import { render } from "./AgentResourceEditor.vue?vue&type=template&id=08c3db2d"
import script from "./AgentResourceEditor.vue?vue&type=script&lang=js"
export * from "./AgentResourceEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__